import { render, staticRenderFns } from "./CleaveCustomized.vue?vue&type=template&id=bc642efe&"
import script from "./CleaveCustomized.vue?vue&type=script&lang=js&"
export * from "./CleaveCustomized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports